import React from 'react';
import { IonIcon } from '@ionic/react';
import { beerOutline, heartOutline, leafOutline, nutritionOutline, restaurantOutline, ribbonOutline, snowOutline, sparklesOutline, thumbsUpOutline, waterOutline } from 'ionicons/icons';
import CatalogoSection from './CatalogoSection';
import { DestaqueProduto, normalizarDestaquesProduto, OPCOES_DESTAQUES_PRODUTO } from './destaquesProduto';
import './DestaquesProdutoEditor.css';

type Props = {
  value: DestaqueProduto[];
  disabled?: boolean;
  onChange: (value: DestaqueProduto[]) => void;
  expanded?: boolean;
  onExpandedChange?: (expanded: boolean) => void;
};

const ICONES: Record<DestaqueProduto, string> = {
  NOVIDADE: sparklesOutline, RECOMENDADO: thumbsUpOutline, FAVORITO: heartOutline,
  VEGANO: leafOutline, VEGETARIANO: restaurantOutline, ZERO_LACTOSE: waterOutline,
  ZERO_ACUCAR: nutritionOutline, ORGANICO: leafOutline, BEBIDA_GELADA: snowOutline,
  BEBIDA_ALCOOLICA: beerOutline, NATURAL: nutritionOutline,
};

const DestaquesProdutoEditor: React.FC<Props> = ({ value, disabled = false, onChange, expanded, onExpandedChange }) => {
  const selecionados = normalizarDestaquesProduto(value);
  const selecionar = (code: DestaqueProduto, checked: boolean) => {
    if (disabled) return;
    onChange(normalizarDestaquesProduto(checked ? [...selecionados, code] : selecionados.filter(item => item !== code)));
  };

  return <CatalogoSection title="Destacar produto" description="Escolha os destaques que aparecem junto do produto no cardápio."
    icon={ribbonOutline} iconColor="#7c3aed" iconBackground="#f3edff" className="catalogo-destaques-card" expanded={expanded} onExpandedChange={onExpandedChange}>
    <fieldset className="catalogo-destaques-options" disabled={disabled} aria-label="Destaques do produto">
      {OPCOES_DESTAQUES_PRODUTO.map(opcao => <label className="catalogo-destaque-option" key={opcao.code}>
        <input type="checkbox" aria-label={opcao.label} aria-describedby={`destaque-descricao-${opcao.code}`}
          disabled={disabled} checked={selecionados.includes(opcao.code)} onChange={event => selecionar(opcao.code, event.target.checked)} />
        <span className="catalogo-destaque-copy">
          <span className="catalogo-destaque-label"><IonIcon icon={ICONES[opcao.code]} aria-hidden="true" />{opcao.label}</span>
          <span className="catalogo-destaque-description" id={`destaque-descricao-${opcao.code}`}>{opcao.description}</span>
        </span>
      </label>)}
    </fieldset>
  </CatalogoSection>;
};

export default DestaquesProdutoEditor;
